var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBzcj = function SvgBzcj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.753V4.247c0-.54-.302-1.035-.77-1.297L7.285.197a1.64 1.64 0 0 0-1.557 0L.771 2.95C.302 3.227 0 3.722 0 4.247v5.492c0 .539.287 1.034.77 1.296l4.96 2.768a1.639 1.639 0 0 0 1.556 0l4.943-2.753c.469-.277.771-.772.771-1.297Zm-8.558-5.65a.42.42 0 0 0-.55 0 .326.326 0 0 0 0 .494L5.562 6.1H3.388c-.215 0-.389.157-.389.35 0 .193.174.35.389.35H6.11v1.4H3.39c-.215 0-.389.157-.389.35 0 .193.174.35.389.35H6.11v1.75c0 .193.174.35.389.35.215 0 .389-.157.389-.35V8.9H9.61c.215 0 .389-.157.389-.35 0-.193-.174-.35-.389-.35H6.89V6.8H9.61c.215 0 .389-.157.389-.35 0-.193-.174-.35-.389-.35H7.44l1.67-1.503a.326.326 0 0 0 0-.494.42.42 0 0 0-.55 0L6.5 5.955 4.442 4.103Z",
    fill: "#fff"
  })));
};

export default SvgBzcj;